import { api } from "@/core/api/";

export default {
    getSpecialistProvider(properties) {
        return api.get("api/specialist/provider", {
            params: {
                ...properties
            }
        });
    },
    getSpecialties(id) {
        return api.get(`api/specialist/${id}/specialties`);
    },
    getActiveSpecialists(academicYearId) {
        return api.get(`api/specialist/active/${academicYearId}`);
    },
    getSpecialtyTypes() {
        return api.get(`api/code/specialties`);
    },

    getSpecialist(properties) {
        return api.get('api/specialist/list', {
          params: {
            ...properties,
          },
        })
      },

    specialistsList(providerId,locationId,disciplineTypeId) {
        return api.get(`api/specialist/memberlist/${providerId}/${locationId}/${disciplineTypeId}`)
    },
    getProviderMunicipalities(companyId) {
        return api.get(`api/specialist/municipalities/${companyId}/providerwithlocationservices`)
    },
    getCompaniesWithContracts(fiscalYearId) {
        return api.get(`api/specialist/list/withsignedcontracts/${fiscalYearId}`)
    },
}